import { Component, OnInit, ViewChild } from '@angular/core';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { TranslateService } from '@ngx-translate/core';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY, SPECIAL_OFFER_STATUS } from 'src/app/extensions/constants/commonConstants';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { NgForm } from '@angular/forms';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';

@Component({
  selector: 'app-special-offers',
  templateUrl: './financing-details.component.html',
  styleUrls: ['./financing-details.component.scss'],
  standalone: false,
})
export class FinancingDetailsComponent implements OnInit {
  @ViewChild('form') public form: NgForm;
  private stateSignalItem: any;
  canUnloadByPassForm: boolean = false;

  public specialOffer: app.models.GetSpecialOfferModel = {
    title: '',
    campaignDocuments: [],
  } as app.models.GetSpecialOfferModel;

  public financingPeriods: { id: number; value: string }[] = [];
  specialOfferId: string;

  constructor(
    private readonly _globalService: GlobalService,
    private readonly _translateService: TranslateService,
    private readonly _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  specialOfferStatus = SPECIAL_OFFER_STATUS;

  ngOnInit(): void {
    this.specialOfferId = this._activatedRoute.snapshot.params['specialOfferId'];
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.SPECIAL_OFFER_DATA);
    if (isNotEmpty(this.stateSignalItem)) {
      this.specialOffer = this.stateSignalItem.data as app.models.GetSpecialOfferModel;
      this.specialOffer.dictionaryCampaignTypeId = this.specialOffer.dictionaryCampaignTypeId.toUpperCase();
    } else {
      this._globalService.setSignalItem(SIGNAL_ITEM_KEY.SPECIAL_OFFER_DATA, undefined);
      if (this.specialOfferId) {
        this._router.navigate([
          SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
          SPECIAL_OFFER_ROUTES.PREVIEW,
          this.specialOfferId,
        ]);
      } else {
        this.firstStepRedirectHandler();
      }
    }
    this.initializeFinancingPeriods();
  }

  redirectToPrevStep() {
    this.canUnloadByPassForm = true;
    this._router.navigate([
      SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
      SPECIAL_OFFER_ROUTES.NEW,
      SPECIAL_OFFER_ROUTES.CAMPAIGN_DETAILS,
      this.specialOfferId ?? '',
    ]);
  }

  nextStepHandler() {
    this.canUnloadByPassForm = true;
    this.stateSignalItem = {
      data: { ...this.stateSignalItem.data, ...this.specialOffer, isFinancialDetailsFormDirty: this.form.dirty },
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.SPECIAL_OFFER_DATA, this.stateSignalItem);
    this._router.navigate([
      SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
      SPECIAL_OFFER_ROUTES.NEW,
      SPECIAL_OFFER_ROUTES.CAMPAIGN_DESCRIPTION,
      this.specialOfferId ?? '',
    ]);
  }

  firstStepRedirectHandler = () => {
    this._router.navigate([
      SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
      SPECIAL_OFFER_ROUTES.NEW,
      SPECIAL_OFFER_ROUTES.CAMPAIGN_DETAILS,
      this.specialOfferId ?? '',
    ]);
  };

  private initializeFinancingPeriods(): void {
    const monthsTranslation = this._translateService.instant('specialOffers.wizard.financingDetails.months');
    const monthTranslation = this._translateService.instant('specialOffers.wizard.financingDetails.month');
    this.financingPeriods = Array.from({ length: 120 }, (_, i) => ({
      id: i + 1,
      value: `${i + 1} ${i === 0 ? monthTranslation : monthsTranslation}`,
    }));
  }
}
